import React from 'react'

const Loader = () => (
    <div className="loader"></div>
)

export { Loader }